import router from '../../router'
import Vue from 'vue'
import moment from 'moment'

export const user = {
    state: {
        status: 'idle',
        userData: null,
        registerDataStatus: 'idle',
        registerData: null,
        userLocations: null,
        mergedUserLocations: null,
        userCompaniesData: null,
        userAllCompaniesData: null,
        activeTab: 0,
        userDeviceType: null,
        permissions: [],
        isStoreDataChanged: false,
        storeDataStatus: 'idle',
        downloadFileStatus: {
            status: 'idle',
            fileId: null
        },
        userLocationsSynchronization: []
    },
    mutations: {
        SET_USER_STATUS(state, payload) {
            state.status = payload
        },
        SET_USER(state, payload) {
            state.userData = payload
            state.permissions = payload.userPermissions
        },
        SET_USER_LOCATIONS(state, payload) {
            state.userLocations = payload
        },
        SET_MERGED_USER_LOCATIONS(state, payload) {
            state.mergedUserLocations = payload
        },
        SET_REGISTER_DATA(state, payload) {
            state.registerData = payload
        },
        SET_REGISTER_DATA_STATUS(state, payload) {
            state.registerDataStatus = payload
        },
        SET_USER_COMPANIES(state, payload) {
            state.userCompaniesData = payload
        },
        SET_USER_ACTIVE_TAB(state, payload) {
            state.activeTab = payload
        },
        SET_USER_DEVICE_TYPE(state, payload) {
            state.userDeviceType = payload
        },
        IS_STORE_DATA_CHANGED(state, payload) {
            state.isStoreDataChanged = payload
        },
        SET_STORE_DATA_STATUS(state, payload) {
            state.storeDataStatus = payload
        },
        SET_USER_ALL_COMPANIES(state, payload) {
            state.userAllCompaniesData = payload
        },
        SET_DOWNLOAD_FILE_STATUS(state, payload) {
            state.downloadFileStatus = payload
        },
        SET_USER_LOCATIONS_SYNCHRONIZATION(state, payload) {
            state.userLocationsSynchronization = payload
        }
    },
    actions: {
        userDataFetch({ state, commit, getters, dispatch }) {
            if (state.status === 'idle') {
                commit('SET_USER_STATUS', 'loading')
                return this.$api
                    .get(`users/${getters.userId}/basicData`)
                    .then(response => {
                        if (
                            response.data.data.userData.type === 'L' &&
                            !response.data.data.userData.subtype
                        ) {
                            router.push({ name: 'logout' })
                            setTimeout(() => {
                                dispatch('addNotification', {
                                    type: 'danger',
                                    title: 'Logowanie',
                                    content:
                                        'Nie posiadasz uprawnień do zalogowania się do panelu detalisty'
                                })
                            }, 100)
                        }

                        commit('SET_USER', response.data.data.userData)
                        commit(
                            'SET_USER_COMPANIES',
                            response.data.data.companiesData
                        )
                    })
                    .catch(error => {
                        console.log(error)
                    })
                    .finally(() => {
                        commit('SET_USER_STATUS', 'idle')
                    })
            }
        },
        extendedDataFetch({ state, commit, getters, dispatch }, payload) {
            if (state.registerDataStatus === 'idle') {
                commit('SET_REGISTER_DATA_STATUS', 'loading')
                return this.$api
                    .get(`users/${getters.userId}/extendedData`, {
                        params: {
                            includes: payload ? payload.includes : null
                        }
                    })
                    .then(response => {
                        if (
                            response.data.data.companies &&
                            response.data.data.companies.length
                        ) {
                            commit(
                                'SET_REGISTER_DATA',
                                response.data.data.companies[0]
                            )
                        }
                        if (
                            response.data.data.locations &&
                            response.data.data.locations.length
                        ) {
                            commit(
                                'SET_USER_LOCATIONS',
                                response.data.data.locations
                            )
                        }
                        return response
                    })
                    .catch(error => {
                        console.log(error)
                    })
                    .finally(() => {
                        commit('SET_REGISTER_DATA_STATUS', 'idle')
                    })
            }
        },
        async locationsSynchronizationFetch({ commit, getters }, payload) {
            try {
                const { data, status } = await this.$api.get(
                    `users/${getters.userId}/ep/extendedData`, {
                        params: {
                            includes: 'locations'
                        }
                    }
                )

                if (status !== 200 || !data?.data) {
                    throw new Error(data.message || 'Error locationsSynchronizationFetch')
                }
                let locations = []
                data.data.companies.forEach(company => {
                    locations = locations.concat(company.locations)
                })

                commit('SET_USER_LOCATIONS_SYNCHRONIZATION', locations)
            } catch (err) {
                console.log(err)
            }
        },
        setRegisterData({ state, dispatch }) {
            const company = state.registerData
            return this.$api
                .post(`/companies/${company.id}/update`, {
                    ...state.registerData
                })
                .then(res => {
                    if (res.data.data.errors && res.data.data.errors.length) {
                        dispatch('addNotification', {
                            type: 'danger',
                            content: 'W formularzu wystąpiły błędy.'
                        })
                    } else {
                        dispatch('addNotification', {
                            type: 'success',
                            content:
                                'Dane zostały przesłane do przetworzenia. Aktualizacja nastąpi wkrótce.'
                        })
                    }
                    return res
                })
        },
        async setUserNewPassword({ commit, dispatch }, payload) {
            try {
                const loginRequest = await this.$api.post('login', {
                    login: payload.login,
                    password: payload.oldPassword
                })
                if (!loginRequest.data.auth.access_token) {
                    throw new Error('err')
                }
                try {
                    const changePasswordRequest = await this.$api.post(
                        'change_user_password',
                        {
                            login: payload.login,
                            password: payload.newPassword,
                            oldPassword: payload.oldPassword
                        }
                    )

                    if (!changePasswordRequest.data.auth.access_token) {
                        throw new Error('err')
                    }

                    const newLoginRequest = await this.$api.post('login', {
                        login: payload.login,
                        password: payload.newPassword,
                        stay_logged: true
                    })

                    if (!newLoginRequest.data.auth.access_token) {
                        throw new Error('err')
                    } else {
                        const token = newLoginRequest.data.auth.access_token
                        commit('SET_AUTH_TOKEN', token)
                        this.$storage.setItem('authToken', token)

                        dispatch('addNotification', {
                            type: 'success',
                            title: 'Logowanie',
                            content: 'Hasło zostało zmienione.'
                        })
                        return newLoginRequest
                    }
                } catch (err) {
                    dispatch('addNotification', {
                        type: 'danger',
                        title: 'Logowanie',
                        content: 'Wprowadzone dane są nieprawidłowe.'
                    })
                }
            } catch (err) {
                dispatch('addNotification', {
                    type: 'danger',
                    title: 'Logowanie',
                    content: 'Błędne aktualne hasło.'
                })
            }
        },
        setUserActiveTab({ state, commit }, payload) {
            commit('SET_USER_ACTIVE_TAB', payload)
        },
        setUserBillingNotifications(
            { getters, dispatch, commit },
            { email, sendNotifications }
        ) {
            const userId = getters.getUser.id

            return this.$api
                .patch(`/users/${userId}`, {
                    notification_email: email,
                    send_notifications: sendNotifications
                })
                .then(res => {
                    if (res.status !== 200) throw res
                    commit('SET_USER', {
                        ...getters.getUser,
                        notificationEmail: email,
                        sendNotificationsStatus: sendNotifications
                    })
                    dispatch('addNotification', {
                        type: 'success',
                        content: 'Dane zostały zapisane'
                    })
                })
                .catch(() => {
                    dispatch('addNotification', {
                        type: 'danger',
                        content: 'Wystąpił błąd. Spróbuj ponownie później.'
                    })
                })
        },
        setUserDeviceType({ commit }, payload) {
            commit('SET_USER_DEVICE_TYPE', payload)
        },
        setMergedUserLocations({ commit }, payload) {
            commit('SET_MERGED_USER_LOCATIONS', payload)
        },
        async saveUserLocation({ dispatch, getters, commit }, payload) {
            let location = getters.getUserLocations.find(
                el => el.location_id === payload.editLocationId
            )
            if (!location) return

            try {
                location = JSON.parse(JSON.stringify(location))
                delete location.devices
                delete location.location_id
                delete location.name
                delete location.pin

                const tempLocation = payload.tempUserLocations.find(
                    el => el.location_id === payload.editLocationId
                )
                const isChangedFullName = tempLocation.full_name !== location.full_name

                commit('SET_STORE_DATA_STATUS', 'loading')

                const { data, status } = await this.$api.post(`/location/${payload.editLocationId}/update`, location)

                if (status !== 200 || data?.data?.error) {
                    dispatch('addNotification', {
                        type: 'danger',
                        content: data?.data?.error || 'W formularzu wystąpiły błędy.'
                    })
                    throw new Error(data?.data?.error || 'Error saveUserLocation')
                }

                dispatch('addNotification', {
                    type: 'success',
                    content: isChangedFullName
                        ? 'Poprawnie zapisano dane. Zmiany będą widoczne w przeciągu kilku minut. Jeśli zmiany nie są widoczne, należy odświeżyć stronę.'
                        : 'Poprawnie zapisano dane.'
                })
                return data
            } catch (err) {
                console.log(err)
            } finally {
                commit('SET_STORE_DATA_STATUS', 'idle')
            }
        },
        updateUserLocation({ dispatch, getters, commit }, payload) {
            const userLocations = getters.getUserLocations
            const locationIdx = userLocations.findIndex(
                el => el.location_id === payload.editLocationId
            )

            userLocations[locationIdx] = {
                ...userLocations[locationIdx],
                ...payload.changedData
            }
            commit('SET_USER_LOCATIONS', userLocations)
            commit('IS_STORE_DATA_CHANGED', true)
        },
        async saveLocationOpeningHours({ dispatch, getters, commit }, payload) {
            delete payload.updatedOpeningHoursData.devices
            delete payload.updatedOpeningHoursData.location_id
            delete payload.updatedOpeningHoursData.name
            delete payload.updatedOpeningHoursData.pin
            commit('SET_STORE_DATA_STATUS', 'loading')
            await this.$api
                .post(`/location/${payload.editLocationId}/update`, {
                    ...payload.updatedOpeningHoursData
                })
                .then(res => {
                    if (res.data.data === '') {
                        commit('IS_STORE_DATA_CHANGED', false)
                        dispatch('updateUserLocation', {
                            editLocationId: payload.editLocationId,
                            changedData: payload.changedData
                        })
                        dispatch('addNotification', {
                            type: 'success',
                            content: 'Poprawnie zapisano dane.'
                        })
                    } else {
                        dispatch('addNotification', {
                            type: 'danger',
                            content: 'W formularzu wystąpiły błędy.'
                        })
                    }
                    return res
                })
                .catch(() => {
                    dispatch('addNotification', {
                        type: 'danger',
                        content: 'W formularzu wystąpiły błędy.'
                    })
                })
            dispatch('toggleModal', false)
            commit('SET_STORE_DATA_STATUS', 'idle')
            commit('IS_STORE_DATA_CHANGED', true)
        },
        fetchAllCompaniesData({ commit, getters }, payload) {
            return this.$api
                .get(
                    `users/${getters.userId}/basicData?includes=inactive_companies`
                )
                .then(response => {
                    commit(
                        'SET_USER_ALL_COMPANIES',
                        response.data.data.companiesData
                    )
                })
                .catch(error => {
                    console.log(error)
                })
        },
        setDownloadFileStatus({ commit }, payload) {
            commit('SET_DOWNLOAD_FILE_STATUS', payload)
        }
    },
    getters: {
        isLotteryUser: state =>
            state.userData &&
            state.userData.type === 'K' &&
            state.userData.subtype === 'L',
        isMainUser: state =>
            state.userData &&
            state.userData.type === 'K' &&
            state.userData.subtype === null,
        isShopUser: state =>
            state.userData &&
            state.userData.type === 'K' &&
            state.userData.subtype === 'S',
        getUserStatus: state => {
            return state.status
        },
        getUser: state => {
            if (state.userData) {
                return state.userData
            }
        },
        getRegisterData: state => {
            if (state.registerData) {
                return state.registerData
            }
        },
        getUserLocations: (state, getters) => {
            if (state.mergedUserLocations) {
                return state.mergedUserLocations
            } else {
                const diagnostics = getters.getLocationsDiagnostics
                const locations = state.userLocations
                if (diagnostics && diagnostics.locations && locations) {
                    let userLocations = []
                    userLocations = diagnostics.locations.map(d => ({
                        ...d,
                        ...locations.find(l => l.id === d.location_id)
                    }))
                    userLocations.forEach(e => {
                        e.address.area = e.address.area?.toString()
                    })
                    return userLocations
                }
            }
        },
        getUserLocationOptions: state => {
            return state.userLocations?.map(el => {
                return {
                    label: el.full_name,
                    value: el.id
                }
            })
        },
        getUserCompaniesData: state => {
            if (state.userCompaniesData) {
                return state.userCompaniesData
            }
        },
        getUserAllCompaniesData: state => {
            if (state.userAllCompaniesData) {
                return state.userAllCompaniesData
            }
        },
        getUserNav: (state, getters) => {
            const nav = [
                {
                    text: getters.isShopUser ? 'Zmień hasło' : 'Moje dane',
                    icon: getters.isShopUser ? 'ChangePassword' : 'MyData',
                    iconSize: 22,
                    route: {
                        name: 'settings'
                    }
                },
                {
                    text: 'Moje sklepy',
                    icon: 'Basket',
                    route: {
                        name: 'user-stores'
                    }
                },
                {
                    text: 'Powiadomienia',
                    icon: 'NotificationBell',
                    iconSize: 22,
                    route: {
                        name: 'settings-notifications'
                    }
                },
                {
                    text: 'Sieci',
                    icon: 'Manage',
                    isHidden:
                        getters.isShopUser ||
                        Vue.prototype.$brand.settings.userNetworks.isHidden,
                    route: {
                        name: 'user-networks'
                    }
                },
                {
                    text: 'Użytkownicy sklepowi',
                    icon: 'UsersManagement',
                    isHidden: getters.isShopUser,
                    iconSize: 18,
                    route: {
                        name: 'store-users'
                    }
                },
                {
                    text: 'Dokumenty',
                    icon: 'Documents',
                    isHidden: getters.isShopUser,
                    iconSize: 21,
                    route: {
                        name: 'documents'
                    }
                },
                {
                    text: 'Zgody',
                    icon: 'Consents',
                    iconSize: 22,
                    route: {
                        name: 'user-consents'
                    }
                }
            ]
            return nav.filter(e => !e.isHidden)
        },
        getUserActiveTab: state => {
            return state.activeTab
        },
        getUserDeviceType: state => {
            return state.userDeviceType
        },
        getAvailableSettlementsMethod() {
            return [
                { label: 'Zasady ogólne', value: 'Zasady ogólne' },
                { label: 'Metoda kasowa', value: 'Metoda kasowa' }
            ]
        },
        isPromoEditPermission: (state, getters) => {
            return (
                (getters.isShopUser &&
                    state.permissions.includes('promotions.edit')) ||
                !getters.isShopUser
            )
        },
        isOwnPromoPermission: (state, getters) => {
            return (
                (getters.isShopUser &&
                    state.permissions.includes('promotions.edit') &&
                    state.permissions.includes('promotions.own.edit')) ||
                !getters.isShopUser
            )
        },
        isProductEansPermission: (state, getters) => {
            return (
                (getters.isShopUser &&
                    state.permissions.includes('promotions.code.mapping')) ||
                !getters.isShopUser
            )
        },
        isRetrPermission: (state, getters) => {
            return (
                state.permissions.includes('retr.all') ||
                getters.isMainUser
            )
        },
        isMyBusinessTermsPermission: (state, getters) => {
            return (
                state.permissions.includes('retr.all') ||
                getters.isMainUser
            )
        },
        getStoreDataChangedValue: (state, getters) => {
            return state.isStoreDataChanged
        },
        getUserLocationById: state => locationId => {
            if (state.userLocations) {
                return state.userLocations.find(loc => loc.id === locationId)
            }
        },
        getAvailableUserLocations: (state, getters) => {
            let availableUserLocations = []
            if (state.userLocations && getters.getAvailableMerchants) {
                const merchants = getters.getAvailableMerchants
                const userLocations = state.userLocations

                availableUserLocations = userLocations
                    .filter(loc => {
                        const merchant = merchants.find(
                            merchant => merchant.location_id === loc.id
                        )
                        return !!merchant
                    })
                    .map(loc => {
                        const merchant = merchants.find(
                            merchant => merchant.location_id === loc.id
                        )
                        return {
                            ...loc,
                            merchant_id: merchant.id
                        }
                    })
            }
            return availableUserLocations
        },
        isEveryLocationAboutToClose: (state, getters) => {
            if (getters.getAvailableUserLocations?.length > 0) {
                return getters.getAvailableUserLocations.every(loc => {
                    return !!loc.closing_date
                })
            } else return false
        },
        getLocationsClosingDates: (state, getters) => {
            if (getters.getAvailableUserLocations) {
                const locations = getters.getAvailableUserLocations
                const closingDates = locations
                    .filter(loc => loc.closing_date)
                    .map(loc => {
                        return {
                            closing_date: moment(loc.closing_date).format(
                                'YYYY-MM-DD HH:mm:ss'
                            ),
                            merchant_id: loc.merchant_id
                        }
                    })

                return closingDates
            }
        },
        getLatestLocationClosingDate: (state, getters) => {
            if (getters.getLocationsClosingDates) {
                return getters.getLocationsClosingDates
                    .map(el => el.closing_date)
                    .sort()
                    .reverse()[0]
            }
        },
        getLocationsWithAllowedClosingDate: (
            state,
            getters
        ) => promoEndDate => {
            if (getters.getAvailableUserLocations) {
                promoEndDate = moment(promoEndDate).format('YYYY-MM-DD')
                const locations = getters.getAvailableUserLocations
                const locationsWithAllowedClosingDate = locations.filter(
                    loc => {
                        return (
                            !loc.closing_date ||
                            moment(loc.closing_date)
                                .subtract(1, 'days')
                                .isAfter(promoEndDate)
                        )
                    }
                )

                return locationsWithAllowedClosingDate
            }
        },
        getUserCompanies: state => {
            if (state.userCompaniesData) {
                return state.userCompaniesData
            }
        },
        getUserCompaniesForSelect: (state, getters) => {
            if (getters.getUserCompanies) {
                return getters.getUserCompanies.map(company => {
                    return {
                        label: company.nip,
                        value: company.nip,
                        tooltipLabel: company.name
                    }
                })
            }
        },
        getUserAllCompaniesForSelect: (state, getters) => {
            if (getters.getUserAllCompaniesData) {
                return getters.getUserAllCompaniesData.map(company => {
                    return {
                        label: company.nip,
                        value: company.nip,
                        tooltipLabel: company.name
                    }
                })
            }
        },
        getStoreDataStatus: state => {
            return state.storeDataStatus
        },
        getDownloadFileStatus: state => {
            return state.downloadFileStatus
        },
        getUserNetworks: (state, getters) => {
            const networks = getters.getAvailableUserLocations.map(
                el => el.network_name
            )
            return [...new Set(networks)]
        },
        getLocationsSynchronization: state => state.userLocationsSynchronization
    }
}
